import React, { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import ClipLoader from "react-spinners/ClipLoader";
import { forgotPasswordThunk } from '../../redux/forgotPasswordSlice';
import { Back } from '../../../Svg';
import styles from './verifyEmail.module.css';
import api from '../../utils/api';
import { toast } from 'react-toastify';

const VerifyEmail = () => {
    const [timer, setTimer] = useState(119);
    const [forgotTrigger, setForgotTrigger] = useState(false);
    const location = useLocation();
    const dispatch = useDispatch();
    const navigate = useNavigate()
    const [isVerifyLoading,setVerifyLoading] = useState(false)
    const { loading, success, error } = useSelector((state) => state.forgotPassword);

    const { email } = location.state || {};
   
   //resetting timer after resending otp
    useEffect(() => {
        if (success && forgotTrigger) {
            setTimer(119);
            setForgotTrigger(false);
        }
    }, [success, forgotTrigger]);


    //timer logic for resend otp
    useEffect(() => {
        let interval;
        if (timer > 0) {
            interval = setInterval(() => {
                setTimer(prevTimer => prevTimer - 1);
            }, 1000);
        } else if (timer === 0) {
            clearInterval(interval);
        }
        return () => clearInterval(interval);
    }, [timer]);

    //resend otp api call
    const resendOtp = () => {
        setForgotTrigger(true);
        dispatch(forgotPasswordThunk(email));
    };

    // Formik Setup
    const formik = useFormik({
        initialValues: {
            otp: '',
        },
        validationSchema: Yup.object({
            otp: Yup.string()
                .required('OTP is required')
                .matches(/^\d{6}$/, 'OTP must be 6 digits'),
        }),
        onSubmit:async (values) => {
            console.log('Submitted OTP:', values.otp);
            //verify otp api call
            try{
                setVerifyLoading(true)
                const response = await api.verifyOtp({email:email, otp:values.otp})
                if(response.data){
                    console.log(response.data);
                    toast.success(response.data?.data?.message || 'Otp verified successfully')
                    navigate('/resetPassword', { state: { email } });

                }
            }catch(err){
                console.log('verify otp error',err?.response);
                
               toast.error(err?.response?.data?.message ||"something went wrong")
            }finally{
                setVerifyLoading(false)
            }
            
        },
    });
   
    return (
        <>
            <div className={styles.loginContainer}>
                <div className={styles.loginInner}>
                    <div className={styles.loginCol1} onClick={() => navigate('/')} style={{ cursor: 'pointer' }}>
                        <img src='/assets/logo.png' alt='logo' />
                    </div>
                    <div className={styles.loginCol2}>
                        <div className={styles.loginCard}>
                            <div className={styles.backLogin}>
                                <Back />
                                <a href="#"><span>Back to login</span></a>
                            </div>
                            <div className={styles.loginContent}>
                                <h3>Verify Email address</h3>
                                <p>We've sent a one-time password (OTP) to your email at {formatEmail(email)}. Please enter it below to verify.</p>
                                
                                <form className={styles.loginForm} onSubmit={formik.handleSubmit}>
                                    <div className={styles.loginInputGroup}>
                                        <label>OTP</label>
                                        <div>
                                            <input
                                                type='text'
                                                placeholder="Enter 6 digits OTP"
                                                className={styles.passwordInput}
                                                id="otp"
                                                name="otp"
                                                value={formik.values.otp}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                maxLength={6}
                                            />
                                            {formik.touched.otp && formik.errors.otp ? (
                                                <div className={styles.error}>{formik.errors.otp}</div>
                                            ) : null}
                                        </div>
                                    </div>
                                    
                                    <button type="submit" className={styles.loginButton} disabled={isVerifyLoading}>{isVerifyLoading ? 'please wait...': 'Verify'}</button>

                                    {timer > 0 ? (
                                        <strong><span style={{ color: 'gray' }}>Resend OTP in </span>{Math.floor(timer / 60)}:{('0' + (timer % 60)).slice(-2)} min</strong>
                                    ) : (
                                        <div>
                                            <div style={{ display: 'flex', justifyContent: 'center', marginTop: 10 }}>
                                                <ClipLoader
                                                    color={'white'}
                                                    loading={loading}
                                                    size={10}
                                                    aria-label="Loading Spinner"
                                                    data-testid="loader"
                                                />
                                            </div>
                                            {!loading && <p>Didn't receive? <span style={{ fontSize: 15, cursor: 'pointer' }} onClick={resendOtp}>Resend OTP</span></p>}
                                        </div>
                                    )}
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default VerifyEmail;


const formatEmail = (email) => {
    if (!email) return '';
    
    const [localPart, domain] = email.split('@');
    const hiddenPart = '*'.repeat(localPart.length - 1); // Replace all but the first character with *
    return `${localPart.charAt(0)}${hiddenPart}@${domain}`;
};